<template>
  <div class="row">
    <div class="col-xs-12 col-md-4">
      <masked-text-box :label="$t('synergrid.config.synergridRef')" data-cy="config-form-synergid-ref" mask="##.##.##" pattern="[0-9]{2}[.][0-9]{2}[.][0-9]{2}" placeholder="##.##.##" required tel v-model="value.synergridRef"></masked-text-box>
    </div>
    <div class="col-xs-12 col-md-4">
      <text-box :label="$t('synergrid.config.group')" data-cy="config-form-synergid-group" required v-model="value.group"></text-box>
    </div>
    <div class="col-xs-12 col-md-4">
      <number-box :label="$t('synergrid.config.power')" data-cy="config-form-synergid-power" required v-model="value.power"></number-box>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Inject } from 'vue-property-decorator'
import { idGenerator } from '@/services'
import { NewRequestInfo } from '@/models'

@Component({
  name: 'synergrid-new-request-form',
})
export default class SynergridNewRequestForm extends Vue {

  //#region [Property]
  @Prop({ type: Object, required: true })
  public readonly value!: NewRequestInfo
  //#endregion

  //#region [Data]
  public fieldId: string = idGenerator.getId()
  public kvaCustom: number | null = null
  //#endregion
}
</script>